import { render, staticRenderFns } from "./withdrawalIndex.vue?vue&type=template&id=22582fa4&scoped=true&"
import script from "./withdrawalIndex.vue?vue&type=script&lang=js&"
export * from "./withdrawalIndex.vue?vue&type=script&lang=js&"
import style0 from "./withdrawalIndex.vue?vue&type=style&index=0&id=22582fa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22582fa4",
  null
  
)

export default component.exports